import { APP_VERSION } from './utils/operational'

export function registerPwa(onUpdate) {
  if (!('serviceWorker' in navigator)) return
  let installPrompt = null

  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault()
    installPrompt = event
    const visits = Number(localStorage.getItem('aden:pwa-visits') || 0) + 1
    localStorage.setItem('aden:pwa-visits', String(visits))
    if (visits >= 5) {
      window.dispatchEvent(new CustomEvent('aden:pwa-install', {
        detail: {
          prompt: async () => {
            await installPrompt?.prompt()
            installPrompt = null
          }
        }
      }))
    }
  })

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(`/sw.js?v=${APP_VERSION}`)
      
      // Checa atualizações imediatamente e ao focar no app (iOS resume)
      registration.update().catch(() => {})
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update().catch(() => {})
        }
      })

      if (registration.waiting) onUpdate?.(registration)
      registration.addEventListener('updatefound', () => {
        const worker = registration.installing
        worker?.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            onUpdate?.(registration)
          }
        })
      })
    } catch {
      /* aplicativo segue sem instalação */
    }
  })
}
